import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';
const ApplicationJson = 'application/json';

class WebSocketAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'System';
  controllerName = 'WebSockets';

  getTokenAsync(clientId) {
    const request = { url: [this.getAPIUrl(), 'token', clientId].join('/') };
    return httpClient.getAsync(request, false, true, ApplicationJson, false);
  }

   /**
   * Thực hiện log thông tin vào elk để tracking
   * @param {*} event
   * @param {*} id
   * HTHIEP 13.07.2023
   */
    logTracking(event, id, retry = false) {
      try {
        if (!window._socketConfigs) {
          return;
        }
        // on/off tracking
        if (!window._socketConfigs.tracking) {
          return;
        }
        const request = {url: `${[this.getAPIUrl(), 'logs', 'tracking'].join('/')}?event=${event}&id=${id}&retry=${retry}`};
        return httpClient.getAsync(request);
      } catch (error) {
        console.log(error);
      }
      return '';
    }
}

export default new WebSocketAPI();
